<app-main-header [name_main]="pageTitle">
  <button mat-flat-button color="primary" [disabled]="isSaving" (click)="saveRule()">
    {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</app-main-header>

<section class="schema-rule-editor">
  <article class="editor-card">
    <header class="editor-card-header">
      <h3>Configuración de la regla</h3>
    </header>

    <form [formGroup]="form" class="rule-form">
      @for (field of formConfig; track field.controlName) {
        <mat-form-field appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          @if (field.type === 'select') {
            <mat-select [formControlName]="field.controlName">
              @for (option of field.options ?? []; track option.label) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          } @else {
            <input matInput [formControlName]="field.controlName" [placeholder]="field.placeholder || ''">
          }
        </mat-form-field>
      }
    </form>
  </article>
</section>
